<div id="notfound">
  <div class="notfound">
    <div class="notfound-404"></div>
    <h1>404</h1>
    <h2>{{ 'error.pageNotFound.title' | translate }}</h2>
    <p>{{ 'error.pageNotFound.message' | translate }}</p>
    <a href="/">{{ 'error.pageNotFound.backToHome' | translate }}</a>
  </div>
</div>